/**
 * @file Created on Mon Nov 26 2018
 * @author wangyongqing <wangyongqing01@baidu.com>
 */
/**
 * @function type
 * @param {any} obj - 被判断的对象
 * @return {string} 返回类型：array/date/string/object/undefined/function/boolean/null/regexp/math 等
 */
const getType = obj =>
    Object.prototype.toString
        .call(obj)
        .slice(8, -1)
        .toLowerCase();

/**
 * 根据传入的类型使用 Object.toString 进行判断
 * @function isType
 * @param {any} obj - 需要判断的类型
 * @param { string} type - 需要判断的类型字符串
 * @return {boolean} 返回判断结果
 * @example
 * isType('', 'String') // true
 * isType(new Date, 'Date') // true
 * isType('', 'Array') // false
 */
export function isType(obj, type) {
    return getType(obj) === type.toLowerCase();
}

export default getType;
